export default "__VITE_ASSET__PK_L0va8__"